var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('search-suggestions-form',{attrs:{"data":_vm.suggestion,"title":_vm.$t('searchSuggestions.edit.title', { name: _vm.suggestion ? _vm.suggestion.keyword : ''}),"submit-loading":_vm.submitLoading},on:{"submit":_vm.onSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }